<template>
  <div class="flex flex-col md:flex-row justify-between w-full flex-wrap gap-6">
    <slot name="breadcrumbs">
      <Breadcrumbs v-if="!isInIframe" :items="breadcrumbsItems" />
    </slot>

    <slot />
  </div>
</template>
<script setup lang="ts">
import { Breadcrumbs, type BreadcrumbItem } from '@exfluential/ui';
import { useIsInIframe } from '~/composables/use-is-in-iframe';

type Props = {
  breadcrumbsItems: BreadcrumbItem[];
};

defineProps<Props>();
const isInIframe = useIsInIframe();
</script>
